import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <div className="hero">
      <div className="hero-content">
        <h1>Welcome to Siddhi Wig</h1>
        <p>Premium Quality Wigs for Your Perfect Look</p>
        <p className="hero-description">
          Discover our exclusive collection of high-quality wigs, hair patches,
          and hairpieces. From mono bases to full lace, we have the perfect
          solution for your hair needs.
        </p>
        <div className="hero-features">
          <div className="feature">
            <span className="feature-icon">✨</span>
            <h3>Premium Quality</h3>
            <p>100% authentic & high-quality hair products</p>
          </div>
          <div className="feature">
            <span className="feature-icon">🚚</span>
            <h3>Fast Delivery</h3>
            <p>Quick and reliable shipping across India</p>
          </div>
          <div className="feature">
            <span className="feature-icon">💬</span>
            <h3>Expert Support</h3>
            <p>Professional consultation & customer care</p>
          </div>
        </div>
      </div>
    </div>
  );
}
